export default "__VITE_ASSET__55ae309b__"